import { Chip } from "@mui/material";



const Tag = ({ status, color, bgcolor, fontSize}) => {
  return (
      <Chip
        size="small"
        label={status.toString().toUpperCase()}
        sx={{
          borderRadius: 1,
          height: '20px',
          backgroundColor: bgcolor ?? 'grey.700',
          color: color ?? 'common.white',
          fontWeight: 500,
          fontSize: fontSize ?? 10,
        }}
      />
  )
}

export default Tag;